// MQTT topic matcher — used by MqttSubscriber to dispatch incoming messages
// to the subscribers whose pattern matches the incoming topic.
//
// Wildcards (per MQTT spec):
//   '+'  matches exactly one path segment.
//   '#'  matches zero or more trailing segments — only meaningful as the
//        last segment.
//
// This implementation deliberately doesn't validate that '#' is in a legal
// position; it simply short-circuits on the first '#' it sees. The cost is
// that a malformed pattern like 'a/#/b' will match anything starting with
// 'a/', which is wrong but also the user's problem for writing it.

export function matchesMqttPattern(pattern: string, topic: string): boolean {
  const pp = pattern.split('/');
  const tp = topic.split('/');
  for (let i = 0; i < pp.length; i++) {
    const p = pp[i];
    if (p === '#') return true;          // matches the rest (incl. nothing)
    if (i >= tp.length) return false;    // pattern still has segments, topic doesn't
    if (p === '+') continue;             // matches exactly one segment
    if (p !== tp[i]) return false;       // literal mismatch
  }
  // All pattern segments matched; require topic to be exactly as long.
  return pp.length === tp.length;
}
